"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const io_1 = require("react-icons/io");
const AdministrateurTable_1 = __importDefault(require("../Tables/AdministrateurTable"));
const ParametresAdmins = () => {
    const [search, setSearch] = react_1.default.useState("");
    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    return (react_1.default.createElement("div", { className: "row mb-4" },
        react_1.default.createElement("div", { className: "col-lg-12" },
            react_1.default.createElement("div", { className: "pb-4 search-group-wrapper" },
                react_1.default.createElement("div", { className: "search-form-group position-relative" },
                    react_1.default.createElement("span", { className: "search-input-icon" },
                        react_1.default.createElement(io_1.IoMdSearch, null)),
                    react_1.default.createElement("input", { type: "search", className: "form-control search-form-control", id: "search", "aria-label": "UsernSearchame", placeholder: "Rechercher...", onChange: handleSearchChange }))),
            react_1.default.createElement("div", { className: "table--wrapper admin-table--wrapper" },
                react_1.default.createElement(AdministrateurTable_1.default, { search: search })))));
};
exports.default = ParametresAdmins;
